import React from 'react';
import { Container } from 'react-bootstrap';

function Cart() {
    return (
        <>
            <section>
                <Container>
                    
                </Container>
            </section>
       </>
    );
}

export default Cart;